import { ListResponse, PaginationRequest, Response } from './client/types'
import { useAPI } from './client/useAPI'

type Segment = {
  operatingCarrier: string
  marketingCarrier: string
  arrivalAirport: string
  departureAirport: string
  arrivalTime: string
  departureTime: string
  duration: number
  aircraft: string
  flightNumber: string
}

type Part = {
  totalDuration: number
  segments: Segment[]
}

export type Flight = {
  cabinClass: string
  completed: boolean
  parts: Part[]
}

export type Passenger = {
  id: string
  firstNameRu: string
  lastNameRu: string
  firstNameEn: string
  lastNameEn: string
  birthdate: string
  gender: string
  countryCode: string
  email: string
  phoneNumber: string
}

export type OrderListItem = {
  id: string
  number: string
  priceAmount: string
  status: string
  createdAt: string
  kupiOrderUuid: string
  pnr?: string
  pcc?: string
  provider?: string
  flight: Flight
  passengers: Passenger[]
}

export type OrdersRequest = PaginationRequest & {
  companyId?: string | null
  status?: string[]
}

type OrdersResponse = ListResponse<OrderListItem>

export const useOrders = () => {
  return useAPI<OrdersResponse, OrdersRequest>('GET', '/orders', {
    withToken: true,
  })
}

export type OrderData = {
  id: string
  number: string
  priceAmount: string
  status: string
  createdAt: string
  kupiOrderUuid: string
  pnr?: string
  providerPnr?: string
  pcc?: string
  provider?: string
  flight: Flight
  passengers: Passenger[]
}

type OrderResponse = Response<OrderData>

export const useOrder = (id: string) => {
  return useAPI<OrderResponse>('GET', `/orders/${id}`, {
    withToken: true,
  })
}

export type RefundOrderRequest = {
  comment: string
}
type RefundOrderResponse = Response<OrderData>

export const useRefundOrder = (id: string) => {
  return useAPI<RefundOrderResponse, RefundOrderRequest>(
    'POST',
    `/orders/${id}/refund`,
    {
      withToken: true,
    }
  )
}

export const useCheckoutOrder = (id: string) => {
  return useAPI<OrderResponse>('POST', `/orders/${id}/checkout`, {
    withToken: true,
  })
}
